"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _redux = require("redux");

var _connectedReactRouter = require("connected-react-router");

var _ModalReducers = _interopRequireDefault(require("../../modules/modals/ModalReducers"));

var _AuthReducers = _interopRequireDefault(require("../../modules/auth/AuthReducers"));

var _AuthActions = require("../../modules/auth/AuthActions");

var _AppActions = require("./AppActions");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function network() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var newState = {
    error: null
  };

  switch (action.type) {
    case 'NETWORK_ERROR':
      newState.error = action.payload.message;
      break;

    default:
  }

  return newState;
}

function ready() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _AuthActions.MEMBER_LOGIN_TRIGGER:
      return true;

    case _AuthActions.MEMBER_TOKEN_LOADED:
      return true;

    case _AppActions.APP_MOUNTED:
      return true;

    default:
      return state;
  }
}

function isLanding() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _AppActions.SHOULD_SHOW_IS_LANDING:
      return action.payload;

    default:
      return state;
  }
}

var createRootReducer = function createRootReducer(history) {
  return (0, _redux.combineReducers)({
    router: (0, _connectedReactRouter.connectRouter)(history),
    // ready: ready,
    // network: network,
    modals: _ModalReducers["default"],
    // auth: AuthReducers,
    // accounts: AccountReducers,
    // paymentDevices: CardReducers,
    // wallets: WalletReducers,
    ready: ready,
    isLanding: isLanding,
    network: network,
    auth: _AuthReducers["default"]
  });
};

var _default = createRootReducer;
exports["default"] = _default;